export const testimonials = [
  {
    id: 1,
    name: '李明',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20avatar%2C%20warm%20friendly%20expression%2C%20clean%20white%20background%2C%20modern%20studio%20lighting%2C%20minimalist%20headshot&width=100&height=100&seq=avatar-01&orientation=squarish',
    role: '漫画爱好者 · 高级会员 2年',
    content: 'JM Comic 是我用过最棒的漫画平台！分类清晰，资源丰富，更新速度也很快。高级会员的离线下载功能太实用了，通勤路上也能看漫画。推荐给所有喜欢漫画的朋友！',
    rating: 5,
  },
  {
    id: 2,
    name: '王晓婷',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20avatar%2C%20gentle%20smile%2C%20clean%20white%20background%2C%20modern%20studio%20lighting%2C%20minimalist%20headshot&width=100&height=100&seq=avatar-02&orientation=squarish',
    role: '同人创作者',
    content: '作为一个同人创作者，JM Comic 给了我一个展示作品的绝佳平台。社区氛围友好，读者反馈积极，平台的版权保护措施也让我很放心。',
    rating: 5,
  },
  {
    id: 3,
    name: '张伟',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20avatar%2C%20confident%20look%2C%20clean%20white%20background%2C%20modern%20studio%20lighting%2C%20minimalist%20headshot&width=100&height=100&seq=avatar-03&orientation=squarish',
    role: '大学生 · 普通会员',
    content: '学生党表示免费阅读功能已经很强大了！每天10话的额度完全够用，画质也很清晰。等以后工作了肯定会升级高级会员支持一下。',
    rating: 4,
  },
  {
    id: 4,
    name: '陈思雨',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20avatar%2C%20warm%20smile%2C%20clean%20white%20background%2C%20modern%20studio%20lighting%2C%20minimalist%20headshot&width=100&height=100&seq=avatar-04&orientation=squarish',
    role: '平面设计师 · 高级会员',
    content: '作为一个设计师，我对画质要求很高。JM Comic的超清画质让我非常满意，每一笔线条都清晰可见。分类导航也很直观，找漫画特别方便。',
    rating: 5,
  },
  {
    id: 5,
    name: '刘洋',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20avatar%2C%20casual%20style%2C%20clean%20white%20background%2C%20modern%20studio%20lighting%2C%20minimalist%20headshot&width=100&height=100&seq=avatar-05&orientation=squarish',
    role: 'IT工程师 · 年度会员',
    content: '年度会员性价比超高！无限阅读+离线下载，出差坐飞机的时候简直救命。App的夜间模式也很贴心，晚上躺床上看漫画眼睛不会累。',
    rating: 5,
  },
  {
    id: 6,
    name: '赵雪儿',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20avatar%2C%20young%20and%20fresh%20look%2C%20clean%20white%20background%2C%20modern%20studio%20lighting%2C%20minimalist%20headshot&width=100&height=100&seq=avatar-06&orientation=squarish',
    role: '高中生 · 普通会员',
    content: '班上同学都在用JM Comic看漫画！最喜欢少女漫画分类，每天放学回家看几话是最开心的时光。希望以后能出更多恋爱题材的作品！',
    rating: 4,
  },
];

export const brandStats = [
  { label: '注册用户', value: '500万+', icon: 'ri-user-line' },
  { label: '漫画作品', value: '10万+', icon: 'ri-book-open-line' },
  { label: '日活跃用户', value: '80万+', icon: 'ri-fire-line' },
  { label: '好评率', value: '98.5%', icon: 'ri-thumb-up-line' },
];